module.exports = __webpack_public_path__ + "static/media/permission (2).bb7a4b5d.svg";